import { Box, LoadingOverlay } from '@mantine/core'
import { RouterPath } from '@/router/paths'
import { useMfaLogin } from '@/session/useMfaLogin'
import { AuthLayout } from '../layout/AuthLayout/AuthLayout'
import { LoginForm } from './LoginForm/LoginForm'
import { OtpHandler } from './OtpForm/OtpHandler'
import { SsoButtons } from './sso/SsoButtons'
import { useLoginRedirectTo } from './useLoginRedirectTo'

export const LoginPage = () => {
  const { login, isPending, state } = useMfaLogin()
  const redirectTo = useLoginRedirectTo()

  if (state?.isMfaRequired) {
    return (
      <AuthLayout variant="large">
        <OtpHandler
          uid={state.uid}
          email={state.email}
          resendKey={state.resendKey}
        />
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <Box pos="relative">
        <LoadingOverlay visible={isPending} />

        <LoginForm
          forgotPasswordLink={RouterPath.forgotPassword}
          onSubmit={login}
        />

        <SsoButtons marginTop="md" redirectTo={redirectTo} />
      </Box>
    </AuthLayout>
  )
}
